import React from 'react'
import { connect } from 'react-redux'
import { Tabs, Tab } from 'react-bootstrap'
import WithAuth from '../../HOCs/WithAuth'

  import {
  userIsStudyCoordinator,
  userIsInvestigator,
  userIsPortalAdmin,
  userIsPharmaVigilance,
  userCanSeeAllRoutes,
  userIsSuperUser,
  userIsDataManager,
} from '../../functions/userPermissions'

import './style.css'

function InstructionsContainer(props) {
  const { currentUser } = props

  const instructionPDFs = {
    'Study Coordinator': require('../../static/pdfs/study_coordinator_instructions.pdf'),
    'Investigator': require('../../static/pdfs/investigator_instructions.pdf'),
    'Pharmacovigilance': require('../../static/pdfs/pharmacovigilance_instructions.pdf'),
    'Guidance': require('../../static/pdfs/guidance_instructions.pdf'),
  }

  let limitedInstructionsTabs = {}

  if (userIsPortalAdmin(currentUser) || userCanSeeAllRoutes(currentUser) || userIsSuperUser(currentUser) || userIsDataManager(currentUser)) {
    limitedInstructionsTabs = { ...instructionPDFs }
  } else if (userIsPharmaVigilance(currentUser)) {
    limitedInstructionsTabs = { 'Pharmacovigilance': instructionPDFs['Pharmacovigilance'] }
  } else if (userIsStudyCoordinator(currentUser)) {
    limitedInstructionsTabs = {
      'Study Coordinator': instructionPDFs['Study Coordinator'],
      'Guidance': instructionPDFs['Guidance'],
    }
  } else if (userIsInvestigator(currentUser)) {
    limitedInstructionsTabs = {
      'Investigator': instructionPDFs['Investigator'],
      'Guidance': instructionPDFs['Guidance'],
    }
  }

  

  return (
    <div id="InstructionsContainer">
      {Object.keys(limitedInstructionsTabs).length > 0 ?
        <>
          <Tabs defaultActiveKey='0'>
            {Object.keys(limitedInstructionsTabs).map((key, index) => {
              return (
                <Tab eventKey={`${index}`} title={key} style={{ height: "85vh" }}>
                  <iframe src={instructionPDFs[key]} title="instructions" />
                </Tab>
              )
            })}
          </Tabs>
        </>
        :
        <center>
          <h5>
            No Instruction to display.
          </h5>
          <h6>
            If you believe this to be in error, please contact <a href="mailto:support@genesisrg.com">support@genesisrg.com</a>
          </h6>
        </center>
      }
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.loginReducer.currentUser,
  }
}

export default WithAuth(connect(mapStateToProps)(InstructionsContainer))
